import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { nowNCFileEventsConfig } from '@v2/pages/machines/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const NCFileEventsStack = createStackNavigator();

const NCFileEventsNavigator = () => {
  return (
    <NCFileEventsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {nowNCFileEventsConfig.map(({ Component, name }) => (
        <NCFileEventsStack.Screen key={name} name={name} component={Component} />
      ))}
    </NCFileEventsStack.Navigator>
  );
};

export { NCFileEventsNavigator };
